import { BroadsiderHudPopup } from '../';
import { StyledGreenScreen } from './GreenScreen.styled';
import { theme } from '../../theme';
import useInterfaceScaling from '../../hooks/useInterfaceScaling';

const GreenScreen = ({ }) => {
  const scale = useInterfaceScaling();
  const bottomOffset = scale === 0.75 ? theme.playbackBarHeightSmaller : theme.playbackBarHeight;
  return (
    <BroadsiderHudPopup  zIndex={98} bottomOffset={`${bottomOffset} + ${theme.frameWidth}`} disableScaling={true}>
      <StyledGreenScreen>
      </StyledGreenScreen>
    </BroadsiderHudPopup>
  );
};

export default GreenScreen;

